var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbanner"},[(_vm.bannerList.length > 0)?_c('el-carousel',{staticClass:"width-s"},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.pkId},[_c('img',{staticClass:"bannerimg",attrs:{"mode":"widthFix","src":item.picture,"alt":""}})])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }